import { Gradient } from "./gradient.js"
import { Shadow } from "./shadow.js"
import { Stroke } from "./stroke.js"

/**
 * @memberOf Tee
 * @class Style and fill properties to display text.
 * @param {Tee.Chart} chart The parent chart this font object belongs to.
 */
export class Font {
	constructor(chart) {
		this.chart = chart
		this.style = "11px Tahoma"
		this.fill = "black"
		this.textAlign = "center"
		this.baseLine = "alphabetic"

		this._g = null
		this._sh = null
		this._s = null
	}

	get gradient() {
		if (!this._g) {
			this._g = new Gradient(this.chart)
		}

		return this._g
	}

	get shadow() {
		if (!this._sh) {
			this._sh = new Shadow(this.chart)
		}

		return this._sh
	}

	get stroke() {
		if (!this._s) {
			this._s = new Stroke(this.chart)
			this._s.fill = ""
		}

		return this._s
	}

	/**
	 * @returns {number} Returns the size of font, or 20 if it can't be guessed.
	 */
	getSize() {
		const parts = this.style.split(" ")

		for (let t = 0; t < parts.length; t++) {
			const size = parseFloat(parts[t])

			if (size) {
				return size
			}
		}

		return 20
	}

	setSize(value) {
		let result = ""
		const parts = this.style.split(" ")

		for (let t = 0; t < parts.length; t++) {
			if (parseFloat(parts[t])) {
				result += `${value}px `
			} else {
				result += `${parts[t]} `
			}
		}

		this.style = result
	}

	prepare() {
		const c = this.chart.ctx

		c.textAlign = this.textAlign
		c.textBaseline = this.baseLine

		if (this._sh) {
			this._sh.prepare(c)
		}

		if (c.font !== this.style) {
			c.font = this.style
		}
	}

	setChart(chart) {
		this.chart = chart

		if (this._g) {
			this._g.chart = chart
		}

		if (this._sh) {
			this._sh.chart = chart
		}

		if (this._s) {
			this._s.setChart(chart)
		}
	}
}
